<template>
  <div class="coupons-template">
    <!--    <h3 class="title">基础信息-新</h3>-->
    <el-form ref="formTemplateRef" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="模板类型" prop="type">
        <el-radio-group style="display: flex;flex-direction: column;" v-model="form.type" v-removeAriaHidden
          :disabled="disabled">
          <el-radio :label="3" style="margin-top: 14px;margin-bottom: 10px;">
            满减券
            <span class="tips">满一定金额后，下单享满减优惠，例:满100减50</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="couponPlatformType === '40' || couponPlatformType === '30' || couponPlatformType === '82'" label="模板名称" prop="name">
        <el-input :disabled="disabled" v-model="form.name" placeholder="请输入模板名称" style="width: 350px;" maxlength="20"
          show-word-limit></el-input>
        <span class="tips">满10减5券，20字以内</span>
      </el-form-item>
      <el-form-item label="优惠内容" prop="floorAmount">
        <div style="display: flex;">
          <el-form-item prop="floorAmount">
            满
            <el-input v-model="form.floorAmount" placeholder="请输入支付金额"
              style="width: 200px; margin-right: 10px;margin-left: 10px;" class="mtop" :disabled="disabled">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="couponPrice">
            ，减
            <el-input v-model="form.couponPrice" placeholder="请输入满减金额" style="width: 200px; margin-left: 10px;"
              class="mtop" :disabled="disabled">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <div class="tips" style="position: relative;">
            订单金额限制范围:1~1000;减免金额限制范围:1~{{ fullReduction }}
            <div v-if="couponPlatformType === '60'" style="position: absolute;top: 20px;left: 0;">当千牛设置与该设置有出入时，默认该设置的值</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="适用影片" prop="movieIdType">
        <el-select v-model="form.movieIdType" placeholder="请选择" :disabled="disabled" @change="changeMovieIdType">
          <el-option v-for="item in movieIdList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div v-if="form.movieIdType === 1" style="display: flex;margin-left: 0px;margin-top: 10px;">
          <el-form-item prop="movieIdSelectList">
            <el-select v-model="form.movieIdSelectList" multiple filterable remote reserve-keyword placeholder="请选择影片"
              collapse-tags style="width: 300px;" :remote-method="remoteMethod" :loading="loadingSelect"
              :disabled="disabled">
              <el-option v-for="item in movieOptions" :key="item.showId" :label="item.showName" :value="item.showId">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="margin-left: 40px;display: flex;">
            <div>已添加影片</div>
            <div>
              <div
                style="width: 400px;height: 150px;background: #f2f2f2;margin-left: 10px;overflow-y: auto;position: relative;">
                <el-tag v-for="(item, index) in movieOptionsList" :key="item.showName" :closable="!disabled" type=""
                  @close="movieClose($event, item)" style="margin: 0 4px;">
                  {{ item.showName }}
                </el-tag>
                <i v-if="loadingMovie" class="el-icon-loading loading-icon"></i>
                <!--                <div v-for="(item,index) in movieOptionsList">-->
                <!--                  {{item.showName}}-->
                <!--                </div>-->
              </div>
              <div v-if="movieOptionsList.length === 0 && !loadingMovie"
                style="color: #F56C6C;font-size: 12px;margin-left: 10px;">请添加适用影片</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="couponPlatformType !== '30'" label="可用影院" prop="cinemaStandardStr" class="cinemaStand-item">
        <el-tooltip class="item" effect="dark" :content="form.cinemaStandardStr" placement="top-start"
          popper-class="tool-tipgz">
          <el-input v-model="form.cinemaStandardStr" placeholder="请筛选影院" disabled style="width: 400px"></el-input>
        </el-tooltip>
        <span type="warning" :class="disabled ? 'cinemaStandBtn_disabled' : 'cinemaStandBtn'"
          @click="cinemaStandBtn">筛选影院</span>
      </el-form-item>
      <el-form-item v-if="couponPlatformType !== '80'" label="可用影厅" prop="hallType">
        <el-select v-model="form.hallType" placeholder="请选择" :disabled="disabled">
          <el-option v-for="item in hallTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用门槛" prop="useTypeRadio">
        <el-radio-group v-model="form.useTypeRadio" :disabled="disabled">
          <el-radio :label="0">无门槛<span v-if="couponPlatformType == '80'" style="color:red;"> (不可叠加使用)</span></el-radio>
          <el-radio :label="1">单笔订单购票数量≥n可用<span v-if="couponPlatformType == '80'" style="color:red;"> (可与同类型其他券叠加使用)</span></el-radio>
        </el-radio-group>
        <el-form-item prop="useType" v-if="form.useTypeRadio === 1">
          购票数量 ≥
          <el-input v-model="form.useType" placeholder="请输入" style="width: 220px" :disabled="disabled"></el-input>
          使用说明：满{{ form.useType }}张票可用
        </el-form-item>
      </el-form-item>
      <!--      <el-form-item label="适用位置" prop="useType">-->
      <!--        <el-select v-model="form.useType" placeholder="请选择" :disabled="disabled">-->
      <!--          <el-option-->
      <!--            v-for="item in useTypeList"-->
      <!--            :key="item.value"-->
      <!--            :label="item.label"-->
      <!--            :value="item.value">-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
    </el-form>
    <div v-if="!(couponPlatformType === '40' || couponPlatformType === '30' || couponPlatformType === '82')" class="plan"></div>
    <!-- 筛选影院 -->
    <filter-cinema v-if="cinemaVisible" v-model="cinemaVisible" @selectCinema="selectCinema"
      :ids="form.cinemaClassifyId" :types="form.cinemaFilterType" :isDisable="disabled" :classifyCodeList="form.classifyCode"
      @close="cinemaVisible = false" />
  </div>
</template>

<script>
import filterCinema from "@/components/FilterCinema.vue";
import mini from "@/api/mini";
const MiniModel = new mini();

export default {
  name: 'CouponsTemplate',
  components: { filterCinema },
  props: {
    form: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    couponPlatformType: {
      type: String,
      default: ''
    },
    fullReduction: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      rules: {
        type: [{ required: true, message: '请选择优惠券类型', trigger: 'change' }],
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
        ],
        floorAmount: [
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          {
            pattern: /^(?:[1-9][0-9]{0,2}|1000)$/,
            message: "请输入整数，金额限制范围:1~1000",
            trigger: ["blur", "change"],
          },
        ],
        couponPrice: [
          { required: true, message: '请输入优惠金额', trigger: 'blur' },
          {
            pattern: this.getAmountPattern(),
            message: `请输入整数，金额限制范围:1~${this.fullReduction}`,
            trigger: ["blur", "change"],
          }
        ],
        cinemaStandardStr: [
          { required: true, message: '请选择可用影院', trigger: 'blur' },
        ],
        hallType: [
          { required: true, message: '请选择可用影厅', trigger: 'change' },
        ],
        useType: [
          {
            required: true,
            message: "请输入应满足购票数量",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+$/.test(value)) {
                callback(new Error("请输入整数"));
              }
              if (Number(value) > 4 || Number(value) < 1) {
                callback(new Error("请输入1-4之间的整数"));
              } else {
                callback();
              }
            },
          },
        ],
        // movieIdSelectList: [
        //   { required: true, message: '请选择适用影片', trigger: 'change' },
        // ],
        useTypeRadio: [{ required: true, message: '请选择使用门槛', trigger: 'change' }],
        movieIdType: [{ required: true, message: '请选择适用影片', trigger: 'change' }],
      },
      useTypeList: [
        {
          value: "",
          label: '请选择'
        },
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
      ],
      hallTypeList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '普通厅可用'
        },
        {
          value: 2,
          label: '特殊厅可用'
        }
      ],
      movieIdList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '指定影片可用'
        }
      ],
      movieOptions: [],//选中影片id
      movieOptionsList: [], // 选中影片列表
      movieOptionsAll: [],// 全部
      cinemaVisible: false, // 筛选影院
      isCheckLook: false, // 是否可查看
      loadingSelect: false, // 影片下拉加载
      cinemaForm: {},
      loadingMovie: false,
    };
  },
  watch: {
    'form.movieIdSelectList': {
      async handler(newVal) {
        // 这里可以添加逻辑来处理影片选择变化
        if (newVal.length > 0) {
          // console.log('AAAAA===3333',this.movieOptionsAll)
          if (this.movieOptionsAll.length) {
            this.movieOptionsList = this.getMovieOptionsByIds(newVal)
          } else {
            // console.log('AAAAA')
            this.loadingMovie = true
            await this.getMovieList()
            // console.log('AAAAA===',this.movieOptionsAll)
            this.movieOptionsList = this.getMovieOptionsByIds(newVal)
            this.loadingMovie = false
          }
        } else {
          this.movieOptionsList = []
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 按已选 ID 的顺序生成影片列表，忽略全量列表中不存在的影片
    getMovieOptionsByIds(movieIds) {
      return movieIds.map(movieId => {
        return this.movieOptionsAll.find(item => {
          return item.showId === movieId
        })
      }).filter(Boolean)
    },

    getAmountPattern() {
      const max = this.fullReduction;
      // 确保最大值是正整数
      if (!Number.isInteger(max) || max < 1) {
        return /^[1-9]\d*$/; // 默认为正整数
      }

      // 处理一位数 (1-max)
      if (max < 10) {
        return new RegExp(`^[1-${max}]$`);
      }

      // 处理两位数 (10-max)
      if (max < 100) {
        const tens = Math.floor(max / 10); // 十位数字
        const units = max % 10; // 个位数字
        if (units === 0) {
          // 补上 max 本身
          return new RegExp(`^(?:[1-9]|[1-${tens - 1}]\\d|${max})$`);
        } else {
          return new RegExp(`^(?:[1-9]|[1-${tens}]\\d|${tens}[0-${units}])$`);
        }
      }

      // 处理三位数 (100-max)
      if (max < 1000) {
        const hundreds = Math.floor(max / 100); // 百位数字
        const remainder = max % 100; // 后两位数字

        if (remainder === 0) {
          // 整百数情况，如500: 1-99, 100-499, 500
          return new RegExp(`^(?:[1-9]\\d?|[1-${hundreds - 1}]\\d{2}|${hundreds}00)$`);
        } else if (hundreds === 1) {
          // 100-199 非整百，如150: 1-99, 100-150
          return new RegExp(`^(?:[1-9]\\d?|1[0-${remainder}])$`);
        } else {
          // 200-max 非整百，如350: 1-99, 100-299, 300-350
          return new RegExp(`^(?:[1-9]\\d?|[1-${hundreds - 1}]\\d{2}|${hundreds}[0-${remainder}])$`);
        }
      }

      // 更大的数值处理
      const maxStr = max.toString();
      const len = maxStr.length;
      const firstDigit = parseInt(maxStr[0], 10);
      console.log('AAAAAAAAAA22')
      // 匹配所有位数小于max的正整数，以及等于max的数
      return new RegExp(`^[1-9]\\d{0,${len - 2}}$|^[1-${firstDigit - 1}]\\d{${len - 1}}$|^${maxStr}$`);
    },

    changeMovieIdType(e) {
      console.log(e, 'eeee')
      if (e === 0) {
        this.form.movieIdSelectList = []
      }
    },
    movieClose(e, i) {
      console.log(e, i, 'eeee', this.form.movieIdSelectList)
      this.form.movieIdSelectList = this.form.movieIdSelectList.filter(item => {
        return item !== i.showId
      })
      console.log(this.form.movieIdSelectList, 'this.form.movieIdSelectList=2')
    },
    open() {
      console.log('openopenopen==12334')
      this.getMovieList('')
    },
    // 选中部分,子传父
    selectCinema(arr, type) {
      console.log(arr, type, '点击确定==子传父111')
      this.form.cinemaFilterType = type
      this.form.cinemaClassifyId = arr.map((item) => item.id);
      this.form.classifyCode = arr.map((item) => item.classifyCode);
      console.log("🚀 ~ selectCinema ~ this.form.classifyCode: ", this.form.classifyCode);
      console.log(this.form.cinemaClassifyId, ' this.form.cinemaClassifyId ')
      if (type) {
        this.form.cinemaStandardStr = arr
          .map((item) => item.name)
          .join(",");
      } else {
        this.form.cinemaStandardStr = '全部影院'
      }
      console.log(this.form.cinemaStandardStr, 'this.form.cinemaStandardStr')
    },
    cinemaStandBtn() {
      if (this.disabled) return
      this.cinemaVisible = true;
    },
    async getMovieList(name) {
      const res = await MiniModel.movieBaseQuery({
        movieName: name,
      })
      console.log(res, 'getMovieListgetMovieList')
      if (res.data.code !== 200) {
        this.$message.error(res.data.message || '获取影片列表失败')
        return
      }
      if (!name) {
        this.movieOptionsAll = res.data.data
      }
      this.movieOptions = res.data.data
    },
    async remoteMethod(query) {
      console.log('AA1')
      if (query !== '') {
        console.log(query, 'AA2')
        this.loading = true;
        await this.getMovieList(query)
        this.loading = false;
      } else {
        this.movieOptions = this.movieOptionsAll
      }
    },
    resetForm() {
      this.$refs.formTemplateRef.clearValidate();
    },
    // 校验
    async calibration() {
      return await new Promise((resolve, reject) => {
        this.$refs.formTemplateRef.validate((valid) => {
          if (valid) {
            if (this.form.movieIdType === 1 && this.movieOptionsList.length === 0) {
              console.log('请选择适用影片err')
              return
            }
            console.log('校验通过==模版', this.form);
            let movieNameStrList = this.movieOptionsList.map(item => item.showName);
            let templateData = {
              couponPrice: Math.round(this.form.couponPrice * 100),
              floorAmount: Math.round(this.form.floorAmount * 100),
              type: this.form.type,
              useType: this.form.useTypeRadio ? this.form.useType : 0,
              name: this.form.name,
              id: this.form.id ? this.form.id : '',
              movieTemplateLimitJson: {
                cinemaClassifyId: this.form.cinemaClassifyId.join(','),
                cinemaClassifyName: this.form.cinemaFilterType ? this.form.cinemaStandardStr : '',
                cinemaFilterType: this.form.cinemaFilterType,
                hallType: this.form.hallType,
                movieIdStr: this.form.movieIdType === 0 ? '' : this.form.movieIdSelectList.join(','),
                movieNameStr: this.form.movieIdType === 0 ? '' : movieNameStrList.join(','),
                classifyCode: this.form.classifyCode.join(','),
              },
            }
            console.log(templateData, 'templateData==111111')
            resolve({
              templateData: templateData
            })
          } else {
            reject(false);
            // return false;
          }

        });
      });

    },
  }
};
</script>

<style scoped lang="less">
.coupons-template {
  padding-top: 10px;
}

.title {
  font-weight: bold;
  color: #222;
}

.tips {
  color: #666;
  margin-left: 20px;
  font-size: 12px;
}

.mtop {
  margin-top: 4px;
}

.item-row /deep/.el-form-item__label {
  color: red;
}

.cinemaStandBtn {
  margin-left: 20px;
  cursor: pointer;
  color: #ff8622;
  text-decoration: underline;
}

.cinemaStandBtn_disabled {
  margin-left: 20px;
  color: #ccc;
  cursor: not-allowed;
  text-decoration: none;
}

.plan {
  border: 1px solid #999;
  margin-bottom: 10px;
}

/deep/.el-radio__input.is-checked+.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}

.loading-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/couponsTemplate.vue